const translations = [
  {
    en:
      "Hey! My name is Valery, I am a Software developer. I've been doing this for a couple of years.",
    es:
      "¡Hola! Mi nombre es Valery, soy un Desarrollador de Software. Ya llevo un par de años haciendolo.",
    it:
      "Ciao! Mi chiamo Valery, sono un sviluppatore di Software. Ho un paio d'anni facendo questo.",
  },

  {
    en:
      "Happy to learn new things, eager to discover new features. Furthermore, I enjoy my time because I love what I do.",
    es:
      "Me encanta aprender cosas nueva, ansioso por descubrir nuevas funcionalidades. Amo lo que hago",
    it:
      "Mi piace imparare nuove robi, desideroso di scoprire nuove funzionalità. Mi piace tantisimo tutto quello che faccio",
  },
  {
    en: "I am really good with integrations among different applications.",
    es: "Soy realmente bueno con las integraciones entre muchas aplicaciones.",
    it: "Sono davvero bravo con le integrazioni tra molte applicazioni.",
  },
  {
    en: "Why don't you send a message first?",
    es: "¿Por qué no enviar un mensaje primero?",
    it: "Perché non inviare prima un messaggio?",
  },
  {
    en: "I'll be more than happy to have a meeting with you.",
    es: "Estaré encantado de tener una reunión contigo.",
    it: "Sarò felice di avere un incontro di lavoro con te",
  },
  {
    en: "At any case...",
    es: "En cualquier caso...",
    it: "Comunque...",
  },
  {
    en: "Read more",
    es: "Leer más",
    it: "Per saperne di più",
  },
  {
    en: "Message",
    es: "Mensaje",
    it: "Messaggio",
  },
  {
    en: "My story",
    es: "Mi historia",
    it: "La mia storia",
  },
  {
    en: "Projects",
    es: "Proyectos",
    it: "Proggeti",
  },
  {
    en: "Home",
    es: "Inicio",
    it: "Inizio",
  },
  {
    en: "My past",
    es: "Mi pasado",
    it: "Il mio passato",
  },
  {
    en: "My present",
    es: "Mi presente",
    it: "Il mio presente",
  },
  {
    en: "My future",
    es: "Mi futuro",
    it: "Il mio futuro",
  },
  {
    en: "Let's see if you have paid attention to",
    es: "Veamos si has prestado atención a",
    it: "Vediamo se hai prestato attenzione a",
  },
  {
    en: "my story",
    es: "mi historia",
    it: "la mia storia",
  },
  {
    en: "Let's play",
    es: "Vamos a jugar",
    it: "Giochiamo",
  },
  {
    en: "Leave for now",
    es: "Salir por ahora",
    it: "Vai via per ora",
  },
  {
    en: "Hello! Welcome to my story.",
    es: "¡Hola! Bienvenido a mi historia.",
    it: "Ciao! Benvenuto alla mia storia.",
  },
  {
    en:
      "Here comes a sum up of my life. Born in Perú 🇵🇪 on 1990, raised in Barcelona 🇪🇸 and I have been living in several places: 🇬🇧, 🇮🇪, 🇫🇮, 🇱🇰, 🇪🇸, 🇮🇹.",
    es:
      "Aquí viene un resumen de mi vida. Nací en Perú 🇵🇪 en 1990, criado en Barcelona 🇪🇸 y he estado viviendo en varios sitios: 🇬🇧, 🇮🇪, 🇫🇮, 🇱🇰, 🇪🇸, 🇮🇹.",
    it:
      "Ecco un riassunto della mia vita. Sono nato in Perù 🇵🇪 nel 1990, sono cresciuto a Barcellona 🇪🇸 e ho vissuto in diversi posti: 🇬🇧, 🇮🇪, 🇫🇮, 🇱🇰, 🇪🇸, 🇮🇹.",
  },
  {
    en:
      "I studied Tourism in university, so I know how to handle clients and also I am able to speak in English 👌🏽, Italian 🤌🏽, Spanish ✌🏽 and Catalan 👍🏽",
    es:
      "Estudié Turismo en la universidad, así que sé cómo manejar clientes, además soy capaz de hablar en Inglés 👌🏽, Italiano 🤌🏽, Español ✌🏽 y Catalán 👍🏽",
    it:
      "Ho studiato Turismo all'università, quindi so come gestire i clienti e sono anche in grado di parlare in inglese 👌🏽, italiano 🤌🏽, spagnolo ✌🏽 e catalano 👍🏽",
  },
  {
    en:
      "I found the programming world at some job because I created some tools. After that, I fell in love instantly...❤️ So I ended up doing a full-stack developer course and finally found a tech job and some projects. 🧑🏽‍💻",
    es:
      "Descubrí el mundo de la programación en un trabajo porque creé algunas herramientas. Después de eso, me enamoré al instante... ❤️ Así que terminé haciendo un curso de desarrollador full-stack y finalmente encontré un trabajo en tecnología y algunos proyectos. 🧑🏽‍💻",
    it:
      "Ho scoperto il mondo della programmazione in un lavoro perché ho creato alcuni strumenti. Dopodiché, me ne sono innamorato all'istante...❤️ Così ho finito per seguire un corso da sviluppatore full-stack e alla fine ho trovato un lavoro nel settore tecnologico e alcuni progetti. 🧑🏽‍💻",
  },
  {
    en:
      "After a few years, I am currently a Solutions Developer. I was lucky to find a job in which I learned a lot. Also, I have created some tools and helped different departments.",
    es:
      "Después de unos años, actualmente soy un Solutions Developer. Tuve la suerte de encontrar un trabajo en el que aprendí mucho. Además, he creado algunas herramientas y he ayudado a diferentes departamentos.",
    it:
      "Dopo alcuni anni, sono attualmente un Solutions Developer. Sono stato fortunato a trovare un lavoro in cui ho imparato molto. Inoltre, ho creato alcuni strumenti e aiutato diversi dipartimenti.",
  },
  {
    en:
      "However, nowadays, I can create integrations to connect applications. Furthermore, I am dealing with client's requests.",
    es:
      "Sin embargo, hoy en día puedo crear integraciones para conectar aplicaciones. Además, me ocupo de las solicitudes de los clientes.",
    it:
      "Tuttavia, oggigiorno, posso creare integrazioni per connettere le applicazioni. Inoltre, mi occupo delle richieste dei clienti.",
  },
  {
    en:
      "As a good student, I am all the time studying and improving my code. Just to face new challenges with a good preparation.",
    es:
      "Como buen estudiante, estoy todo el tiempo estudiando y mejorando mi código, solo para enfrentar nuevos desafíos con una buena preparación.",
    it:
      "Da bravo studente, studio e miglioro costantemente il mio codice. Solo per affrontare nuove sfide con una buona preparazione.",
  },
  {
    en:
      "My future is becoming quite interesting, I am gathering different projects, not only personals. So in case you would like to hire, I'll be more than happy to assist you.",
    es:
      "Mi futuro se está volviendo bastante interesante, estoy reuniendo diferentes proyectos, no solo personales. Así que en caso de que desees contratar, estaré más que feliz de ayudarte.",
    it:
      "Il mio futuro sta diventando piuttosto interessante, sto raccogliendo progetti diversi, non solo personali. Quindi, nel caso volessi assumere, sarò più che felice di aiutarti.",
  },
  {
    en: "I was born in South America, however, do you remember in which country was?",
    es: "Nací en Sudamérica, sin embargo ¿recuerdas en qué país fue?",
    it: "Sono nato in Sud America, ma ti ricordi in quale Paese ero?",
  },
  {
    en: "Which one is the language that I am not able to speak?",
    es: "¿Cual es el idioma que no puedo hablar?",
    it: "Quale lingua non so parlare?"
  },
  {
    en: "I had to study and work for 4 years to get a degree, do you remember which career I did?",
    es: "Tuve que estudiar y trabajar durante 4 años para poder obtener un título, ¿recuerdas qué carrera hice?",
    it: "Ho dovuto studiare e lavorare per 4 anni per conseguire una laurea, ti ricordi che carriera ho intrapreso?"
  },
  {
    en: "How did I discover the programming world?",
    es: "¿Cómo descubrí el mundo de la programación?",
    it: "Come ho scoperto il mondo della programmazione?"
  },
  {
    en: "Do you remember which job position I have now?",
    es: "¿Recuerdas qué puesto de trabajo tengo ahora?",
    it: "Ti ricordi che posizione lavorativa ho adesso?"
  },
  {
    en: "Brazil",
    es: "Brasil",
    it: "Brasile"
  },
  {
    en: "Perú",
    es: "Perú",
    it: "Perù"
  },
  {
    en: "German",
    es: "Alemán",
    it: "Tedesco"
  },
  {
    en: "Catalan",
    es: "Catalán",
    it: "Catalano"
  },
  {
    en: "Galician",
    es: "Gallego",
    it: "Gallego"
  },
  {
    en: "English",
    es: "Inglés",
    it: "Inglese"
  },
  {
    en: "Spanish",
    es: "Español",
    it: "Spagnolo"
  },
  {
    en: "Italian",
    es: "Italiano",
    it: "Italiano"
  },
  {
    en: "Portuguese",
    es: "Portugués",
    it: "Portoghese"
  },
  {
    en: "Economics",
    es: "Economia",
    it: "Economia"
  },
  {
    en: "Medicine",
    es: "Medicina",
    it: "Medicinale"
  },
  {
    en: "Tourism",
    es: "Turismo",
    it: "Turismo"
  },
  {
    en: "Laws",
    es: "Derecho",
    it: "Giurisprudenza"
  },
  {
    en: "creating tools for a company",
    es: "creando herramientas",
    it: "creare strumenti per un'azienda"
  },
  {
    en: "cycling through a mountain",
    es: "andar en bicicleta por una montaña",
    it: "pedalare attraverso una montagna"
  },
  {
    en: "sleeping like a dog",
    es: "durmiendo como un perro",
    it: "dormire come un cane"
  },
  {
    en: "watching Grey's Anatomy",
    es: "Viendo Anatomía de Grey",
    it: "Guardare Grey's Anatomy"
  },
  {
    en: "Math teacher",
    es: "Profesor de matemáticas",
    it: "Professore di matematica"
  },
  {
    en: "Hotel receptionist",
    es: "Recepcionista de hotel",
    it: "Receptionist dell'hotel"
  },
  {
    en: "Football player",
    es: "Jugador de fútbol",
    it: "Giocatore di calcio"
  },
  {
    en: "Solutions Developer",
    es: "Solutions Developer",
    it: "Solutions Developer"
  },
  {
    en: "Your score is",
    es: "Tu puntaje es",
    it: "Il tuo punteggio è"
  },
  {
    en: "of",
    es: "de",
    it: "su"
  },
  {
    en: "Question",
    es: "Pregunta",
    it: "Domanda"
  },
  {
    en: "Your name",
    es: "Tu nombre",
    it: "Il tuo nome"
  },
  {
    en: "Your email",
    es:"Tu email",
    it:"Il tuo email"
  },
  {
    en: "Your number",
    es:"Tu número",
    it:"Il tuo telefono"
  },
  {
    en: "Your message",
    es:"Tu mensaje",
    it:"Il tuo messaggio"
  },
  {
    en: "Send",
    es:"Enviar",
    it:"Invia"
  },
  {
    en: "Close",
    es:"Cerrar",
    it:"Chiudere"
  },
  {
    en: "Please fill in to contact me",
    es:"Por favor rellena para contactarme",
    it:"Per favore compila per contattarmi"
  }
];

const translated = (text) => {
  const langSelected = localStorage.getItem("currentLang") || "en";

  const translation = translations.find((item) => item.en === text);

  return translation ? translation[langSelected] : text;
};

export default translated;
